import { DataTableHeaderRow, Flex, SegmentedControl, TextLabel } from '@customerio/pluma-components/react';
import type { PeopleSearchBy } from '../hooks';
import { EmailSearch } from './email-search';
import { PeopleFilterBuilder, type PeopleFilterBuilderProps } from './people-filter-builder/people-filter-builder';

const FILTER_BY_LABEL_ID = 'people-filter-by-label';

const SEARCH_BY_OPTIONS = [
  { label: 'Email address', value: 'email' },
  { label: 'Conditions', value: 'filter' },
];

type PeopleSearchSlotProps = {
  activeSearchBy: PeopleSearchBy;
  onActivateSearchBy: (searchBy: PeopleSearchBy) => void;
  email: string;
  onSearch: (term: string) => void;
  filters: string | null;
  onApplyFilters: PeopleFilterBuilderProps['onChange'];
};

/**
 * The search rows of the People table header: the "Filter by" mode control,
 * then either the email search or the condition builder for the active mode.
 */
export function PeopleSearchSlot({
  activeSearchBy,
  onActivateSearchBy,
  email,
  onSearch,
  filters,
  onApplyFilters,
}: PeopleSearchSlotProps) {
  return (
    <>
      <DataTableHeaderRow>
        <Flex alignItems="center" gap="150">
          <TextLabel id={FILTER_BY_LABEL_ID}>Filter by</TextLabel>
          <SegmentedControl
            size="sm"
            name="toggleFilterBy"
            ariaLabelledby={FILTER_BY_LABEL_ID}
            value={activeSearchBy}
            options={SEARCH_BY_OPTIONS}
            onChange={(value: string) => onActivateSearchBy(value === 'filter' ? 'filter' : 'email')}
          />
        </Flex>
      </DataTableHeaderRow>

      <DataTableHeaderRow overflow="visible">
        {activeSearchBy === 'email' ? (
          <EmailSearch term={email} onSearch={onSearch} />
        ) : (
          <PeopleFilterBuilder filters={filters} onChange={onApplyFilters} />
        )}
      </DataTableHeaderRow>
    </>
  );
}
